<template>
  <div class="flex-bubble" :style="bubbleStyle">
    <div v-if="bubble.header" class="flex-header" :style="sectionStyle(bubble.header)">
      <FlexNode :node="bubble.header" />
    </div>
    <div v-if="bubble.hero" class="flex-hero">
      <FlexNode :node="bubble.hero" />
    </div>
    <div v-if="bubble.body" class="flex-body" :style="sectionStyle(bubble.body)">
      <FlexNode :node="bubble.body" />
    </div>
    <div v-if="bubble.footer" class="flex-footer" :style="sectionStyle(bubble.footer)">
      <FlexNode :node="bubble.footer" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import FlexNode from './FlexNode.vue';

const props = defineProps({
  bubble: { type: Object, required: true }
});

const BUBBLE_WIDTHS = {
  nano: 120, micro: 150, kilo: 220, mega: 280, giga: 280
};

const bubbleStyle = computed(() => {
  const size = props.bubble.size || 'mega';
  return {
    maxWidth: (BUBBLE_WIDTHS[size] || 300) + 'px',
    background: props.bubble.styles?.body?.backgroundColor || '#FFFFFF'
  };
});

function sectionStyle(section) {
  const s = {};
  if (section.backgroundColor) s.background = section.backgroundColor;
  const pa = section.paddingAll || section.padding;
  if (pa) {
    s.padding = pa;
  }
  return s;
}
</script>

<style scoped>
.flex-bubble {
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,0,0,.12);
  background: #fff;
}
.flex-header {
  padding: 12px 16px;
}
.flex-hero {
  overflow: hidden;
}
.flex-body {
  padding: 16px;
}
.flex-footer {
  padding: 12px 16px;
}
</style>
